<template>
  <SideBarLayoutContent>
    <template #top-bar>
      <h1 class="text-display-small">{{ $t('mainNavigation.currentDialog') }}</h1>
    </template>
    <LoadingWrapper :state="status">
      <ul v-if="data.coachingRelations.length > 0" class="flex flex-col gap-4">
        <li v-for="coaching in data.coachingRelations" :key="coaching.coach.id">
          <CoacheeDialogCard
            v-if="coaching.latestDialog"
            :dialog="{
              ...coaching.latestDialog,
              coachee: user,
              coach: coaching.coach,
            }"
          />
        </li>
      </ul>

      <EmptyPage
        v-else
        title="Keine Inhalte gefunden"
        description="Du hast momentan keine aktiven Dialoge oder offenen Aufgaben."
        icon="forum"
      />
    </LoadingWrapper>
  </SideBarLayoutContent>
</template>

<script lang="ts" setup>
  import SideBarLayoutContent from '../../../core/components/layouts/SideBarLayoutContent.vue'
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import EmptyPage from '../../../core/components/empty-states/EmptyPage.vue'

  import { useCurrentDialogs } from '../composable/use-current-dialogs'
  import CoacheeDialogCard from '@/modules/coachees/components/CoacheeDialogCard.vue'
  import { useUserStore } from '@/stores/user.store'

  const { status, data } = useCurrentDialogs()
  const { user } = useUserStore()
</script>
